import React, { FC } from 'react'
import classNames from 'classnames'
import { useSelector } from 'react-redux'
import Modal from 'components/SA/Modal/v2'
import useModal from 'hooks/useModal'
import { getUserID, getUserEmail, getFirstAndLastName } from 'selectors/user/session'
import RequestSupportForm from './RequestSupportForm'
import styles from './RequestSupportModal.module.scss'

const MODAL_NAME = 'requestSupport'

type Props = {
  triggerClassName?: string
}

const RequestSupportModal: FC<Props> = ({ triggerClassName }) => {
  const userId = useSelector(getUserID)
  const email = useSelector(getUserEmail)
  const names = useSelector(getFirstAndLastName)
  const { showModal, closeModal } = useModal()

  return (
    <>
      <button
        type='button'
        aria-haspopup='dialog'
        className={classNames(triggerClassName, styles.triggerButton)}
        onClick={() => showModal(MODAL_NAME)}
      >
        Request Support
      </button>

      <Modal name={MODAL_NAME} isCloseButtonVisible modalContentOverride={styles.modalContent}>
        <div className={styles.modalInner}>
          <RequestSupportForm
            userId={userId}
            email={email}
            names={names}
            onClose={closeModal}
          />
        </div>
      </Modal>
    </>
  )
}

export default RequestSupportModal
